<!--
 * @description: 高德地图
 * @author: zb
 * @update: zb
 * @Date: 2019-08-07 17:35:32
 * @LastEditors: zb
 * @LastEditTime: 2019-08-08 18:04:32
 -->
<template>
  <el-amap :amap-manager="amapManager" class="amap-box" :vid="'amap-vue'">
    <el-amap-marker v-for="(marker, index) of markers" :key="`marker ${index}`" :vid="`component-marker${index}`" :position="marker.point" :icon="marker.icon" :ext-data="marker.extData" />
    <el-amap-bezier-curve
      v-for="(line,index) in lines"
      :key="`line ${index}`"
      :cursor="line.cursor"
      :ext-data="line.extData"
      :vid="`component-line${index}`"
      :events="line.events"
      :path="line.path"
      :stroke-color="line.strokeColor"
      :stroke-style="line.strokeStyle"
      :stroke-weight="line.strokeWeight"
      :stroke-opacity="line.strokeOpacity"
    />
    <el-amap-info-window
      v-for="(window,index) in windowInfos"
      :key="`window ${index}`"
      :vid="`component-window${index}`"
      :position="window.position"
      :content="window.content"
      :visible="window.visible"
      :events="window.events"
      :close-when-click-map="true"
    />
  </el-amap>
</template>
<script>
import VueAMap from 'vue-amap'
const amapManager = new VueAMap.AMapManager()
export default {
  name: 'ZMap',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    markers: {
      type: Array,
      default: () => []
    },
    lines: {
      type: Array,
      default: () => []
    },
    windowInfos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      amapManager: amapManager
    }
  },
  watch: {
    data: function() {
      this.setFitView()
    }
  },
  created: function() {

  },
  mounted() {
    setTimeout(
      () => {
        const map = this.amapManager.getMap()
        map.on('complete', () => {
          this.setFitView()
          this.complete()
        })
      }, 500
    )
  },
  beforeDestroy() {

  },
  methods: {
    setFitView() {
      setTimeout(data => {
        this.amapManager.getMap().setFitView()
      }, 500)
    },
    complete() {
      this.$emit('complete', true)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>

